<aside class="right-sidebar p-col-fixed">
  <div class="right-sidebar__wrapper p-grid p-dir-col p-nogutter height-100">
    <div class="p-col height-100">
      <pt-active-order-panel></pt-active-order-panel>
    </div>
  </div>
</aside>
